var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSir(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    style: {
      fill: "#213990"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.67 51.319c.191 1.385.569 2.421 1.131 3.107 1.03 1.248 2.792 1.873 5.289 1.873 1.495 0 2.71-.165 3.643-.494 1.77-.631 2.654-1.804 2.654-3.52 0-1-.439-1.776-1.317-2.325-.878-.535-2.257-1.008-4.136-1.42l-3.21-.72c-3.156-.713-5.337-1.488-6.545-2.325-2.044-1.4-3.066-3.588-3.066-6.565 0-2.716.988-4.973 2.963-6.77 1.976-1.797 4.878-2.696 8.705-2.696 3.197 0 5.924.847 8.18 2.541 2.257 1.695 3.44 4.154 3.55 7.378H30.42c-.11-1.825-.905-3.121-2.387-3.89-.988-.507-2.216-.761-3.684-.761-1.632 0-2.936.33-3.91.988-.974.658-1.46 1.578-1.46 2.757 0 1.084.48 1.894 1.44 2.429.617.356 1.934.775 3.95 1.255l5.228 1.255c2.29.549 4.02 1.283 5.186 2.202 1.81 1.427 2.716 3.492 2.716 6.194 0 2.772-1.06 5.073-3.18 6.905-2.119 1.831-5.113 2.747-8.982 2.747-3.951 0-7.058-.902-9.322-2.706-2.264-1.804-3.396-4.284-3.396-7.44h6.05ZM40.697 30.349h6.297v30.333h-6.297zM58.239 35.617v8.15h7.182c1.426 0 2.496-.166 3.21-.495 1.262-.576 1.893-1.715 1.893-3.416 0-1.838-.61-3.073-1.831-3.704-.686-.357-1.715-.535-3.087-.535h-7.367ZM71.83 31.13a7.669 7.669 0 0 1 2.912 2.12 9.392 9.392 0 0 1 1.564 2.551c.384.933.576 1.996.576 3.19 0 1.44-.364 2.857-1.09 4.25-.728 1.392-1.928 2.376-3.602 2.952 1.4.563 2.39 1.362 2.974 2.398.583 1.036.874 2.617.874 4.743v2.038c0 1.385.055 2.325.165 2.819.165.782.549 1.358 1.152 1.728v.762H70.38a21.756 21.756 0 0 1-.411-1.626 14.938 14.938 0 0 1-.268-2.613l-.041-2.82c-.028-1.934-.38-3.224-1.06-3.868-.68-.645-1.951-.968-3.817-.968h-6.544v11.895h-6.195V30.349h14.879c2.126.04 3.762.302 4.908.782Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSir);
export default __webpack_public_path__ + "static/media/sir.af26a714e202add5adf7810bb081e0f4.svg";
export { ForwardRef as ReactComponent };